var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Boxtype"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": _vm.$t('wipInventory.wipInventorySummary')
    },
    on: {
      "click": function($event) {
        _vm.resetCommonData()
      }
    }
  }, [_c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.stockTypeField')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stocktype),
      expression: "stocktype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "stocktype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.stocktype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.stockType')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accept"
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Reject"
    }
  }, [_vm._v("Reject")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "eancode",
      "type": "text",
      "placeholder": _vm.$t('common.eanCodePHolder')
    },
    model: {
      value: (_vm.eancode),
      callback: function($$v) {
        _vm.eancode = $$v
      },
      expression: "eancode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showWipInventorySummary1()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n                                                    " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                                                    " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('wipInventory.wipInventorySummary')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('dataUploadLogs.totalRecords')) + " - " + _vm._s(_vm.totalRows))])]), _vm._v(" "), _c('div', {
    staticClass: " cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-250px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listWipInventoryData.length > 0) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype2()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listWipInventoryData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": _vm.$t('common.downloadCsv')
    },
    on: {
      "click": function($event) {
        _vm.showWipInventorySummary(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listWipInventoryData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton ",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": _vm.$t('moveOrderList.downloadXLS'),
      "data": _vm.listWipInventoryReportDataforxls,
      "header": _vm.dataFilter2,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.skuID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.ean')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.totalWipInventory')) + " ( " + _vm._s(_vm.totalBucketCount.totalInventory) + " )")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('i', {
    staticClass: "fa fa-briefcase",
    staticStyle: {
      "margin-top": "4px",
      "float": "left"
    },
    attrs: {
      "title": "Accept Reject Stock type not applicable for In GRN Bucket"
    }
  }), _vm._v(_vm._s(_vm.$t('wipInventory.inGrn')) + " ( " + _vm._s(_vm.totalBucketCount.grn) + " )")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.inPutaway')) + " ( " + _vm._s(_vm.totalBucketCount.putaway) + " )")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.inPacking')) + " ( " + _vm._s(_vm.totalBucketCount.packing) + " )")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.inShipping')) + " ( " + _vm._s(_vm.totalBucketCount.shipping) + " )")])])]), _vm._v(" "), _c('tbody', [(_vm.client == '' && _vm.warehouse == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "30",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientNoWarehouseMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.client == '' && _vm.warehouse != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "30",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse == '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "30",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehouseSelectHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "30",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noSearchBtnMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.warehouse != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "30",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listWipInventoryData), function(data) {
    return _c('tr', {
      staticClass: "text-center "
    }, [_c('td', [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.calculateTotalWipCount(data)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.viewGRNSummary(data)
        }
      }
    }, [_vm._v(_vm._s(Number(data.grnpendingqty)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.viewPutawaySummary(data)
        }
      }
    }, [_vm._v(_vm._s(Number(data.putawaypedningqty)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.viewPackingSummary(data)
        }
      }
    }, [_vm._v(_vm._s(Number(data.packpedningqty)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.viewShippingSummary(data)
        }
      }
    }, [_vm._v(_vm._s(Number(data.shippedningqty)))])])
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listWipInventoryData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit1,
      "current-page": _vm.currentPage1
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('crossDock.BucketWiseDetail')
    },
    on: {
      "click": function($event) {
        _vm.selectbucketwise = true
      }
    }
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.stockTypeField')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stocktype),
      expression: "stocktype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "stocktype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.stocktype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.stockType')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accept"
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Reject"
    }
  }, [_vm._v("Reject")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "eancode",
      "type": "text",
      "placeholder": _vm.$t('common.eanCodePHolder')
    },
    model: {
      value: (_vm.eancode),
      callback: function($$v) {
        _vm.eancode = $$v
      },
      expression: "eancode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showBucketWiseStock1
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n                                                        " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                                                        " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])])], 1), _vm._v(" "), _c('div', [_c('b-tabs', {
    staticClass: "custom-tabs-bg"
  }, [_c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('crossDock.Ingrn'),
      "active": ""
    },
    on: {
      "click": function($event) {
        _vm.getbucketdetail('in_grn')
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('dataUploadLogs.totalRecords')) + "  -" + _vm._s(_vm.totalRows) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), (_vm.download && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype1('in_grn', 3)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": "Download CSV",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.downloadbucketwisewipReport('in_grn', 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": "Download Excel",
      "data": _vm.listBucketwiseDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.skuID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.ean')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.totalWipInventory')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(" " + _vm._s(_vm.$t('crossDock.po')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-sm btn-info download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_grn_po')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('crossDock.Returns')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-info btn-sm download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_grn_returns')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()])])]), _vm._v(" "), _c('tbody', [(_vm.listGRNData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listGRNData), function(data, index) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.poqty) + Number(data.rtnqty)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_grn_po', data)
        }
      }
    }, [_vm._v(_vm._s(data.poqty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_grn_returns', data)
        }
      }
    }, [_vm._v(_vm._s(data.rtnqty))])])
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listGRNData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChangeBucketWise
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('wipInventory.inPutaway')
    },
    on: {
      "click": function($event) {
        _vm.getbucketdetail('in_putaway')
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('dataUploadLogs.totalRecords')) + " - " + _vm._s(this.resultCount) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), (_vm.download && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype1('in_putaway', 3)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": "Download CSV",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.downloadbucketwisewipReport('in_putaway', 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": "Download Excel",
      "data": _vm.listBucketwiseDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table2"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.skuID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.ean')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.totalWipInventory')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('crossDock.po')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-info btn-sm download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_putaway_po')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('crossDock.Returns')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-info btn-sm download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_putaway_returns')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('crossDock.cancelModifyPutaway')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-info btn-sm download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_putaway_cancle_modify')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('crossDock.moveOrder')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-info btn-sm download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_putaway_moveorder')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()])])]), _vm._v(" "), _c('tbody', [(_vm.listGRNData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listGRNData), function(data, index) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.poqty) + Number(data.moveqty) + Number(data.cancleqty) + Number(data.rtnqty)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_putaway_po', data)
        }
      }
    }, [_vm._v(_vm._s(data.poqty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_putaway_returns', data)
        }
      }
    }, [_vm._v(_vm._s(data.rtnqty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_putaway_cancle_modify', data)
        }
      }
    }, [_vm._v(_vm._s(data.cancleqty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_putaway_moveorder', data)
        }
      }
    }, [_vm._v(_vm._s(data.moveqty))])])
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listGRNData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChangeBucketWise
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('wipInventory.inPacking')
    },
    on: {
      "click": function($event) {
        _vm.getbucketdetail('in_packing')
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('dataUploadLogs.totalRecords')) + " -" + _vm._s(this.resultCount) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), (_vm.download && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype1('in_packing', 3)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": "Download CSV",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.downloadbucketwisewipReport('in_packing', 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": "Download Excel",
      "data": _vm.listBucketwiseDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table3"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.skuID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.ean')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.totalWipInventory')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('createsr.salesOrder')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-info btn-sm download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_packing_order')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.rtv')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-info btn-sm download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_packing_rtv')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.gatepass')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-info btn-sm download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_packing_getpass')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listGRNData), function(data, index) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.rtv_pen_qty) + Number(data.getpass_pen_qty) + Number(data.packing_pen_qty)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_packing_order', data)
        }
      }
    }, [_vm._v(_vm._s(data.packing_pen_qty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_packing_rtv', data)
        }
      }
    }, [_vm._v(_vm._s(data.rtv_pen_qty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_packing_getpass', data)
        }
      }
    }, [_vm._v(_vm._s(data.getpass_pen_qty))])])
  }))])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listGRNData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChangeBucketWise
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('wipInventory.inShipping')
    },
    on: {
      "click": function($event) {
        _vm.getbucketdetail('in_shipping')
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('dataUploadLogs.totalRecords')) + " -" + _vm._s(this.resultCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), (_vm.download && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype1('in_shipping', 3)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": "Download CSV",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.downloadbucketwisewipReport('in_shipping', 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listGRNData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": "Download Excel",
      "data": _vm.listBucketwiseDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table4"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.skuID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.ean')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.totalWipInventory')) + " ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('createsr.salesOrder')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-info btn-sm download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_shipping_order')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.rtv')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-info btn-sm download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_shipping_rtv')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.gatepass')) + "\n                                            "), (_vm.listGRNData.length > 0) ? _c('button', {
    staticClass: "btn btn-info btn-sm download-button",
    on: {
      "click": function($event) {
        _vm.downloadwipReport('in_shipping_getpass')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()])])]), _vm._v(" "), _c('tbody', [(_vm.listGRNData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listGRNData), function(data, index) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.rtv_pen_qty) + Number(data.getpass_pen_qty) + Number(data.packing_pen_qty)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_shipping_order', data)
        }
      }
    }, [_vm._v(_vm._s(data.packing_pen_qty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_shipping_rtv', data)
        }
      }
    }, [_vm._v(_vm._s(data.rtv_pen_qty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showgrndetails(data.eancode, 'in_shipping_getpass', data)
        }
      }
    }, [_vm._v(_vm._s(data.getpass_pen_qty))])])
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listGRNData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChangeBucketWise
    }
  }) : _vm._e()], 1)])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    staticClass: "alocationPopUp",
    attrs: {
      "size": "lg",
      "title": _vm.$t('crossDock.InGrnDetails')
    },
    model: {
      value: (_vm.showGRNDetails),
      callback: function($$v) {
        _vm.showGRNDetails = $$v
      },
      expression: "showGRNDetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('crossDock.WIPBucketDetailsInGRN')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showGRNDetails = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.sku')) + " : " + _vm._s(_vm.sku) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.sku')) + " : " + _vm._s(_vm.eancode1) + " ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px",
      "padding": "10px"
    }
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseSummary')))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [(_vm.showPODetails) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('crossDock.po')))])]) : _vm._e(), _vm._v(" "), (_vm.showReturnsDetails) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('crossDock.Returns')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center cardreporttabletr"
  }, [(_vm.showPODetails) ? _c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket['in_grn_po']) + " ")]) : _vm._e(), _vm._v(" "), (_vm.showReturnsDetails) ? _c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket['in_grn_returns']))]) : _vm._e()])])])]), _vm._v(" "), (_vm.GRNReturnsData.length > 0 || _vm.GRNPOData.length > 0) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseDetails')) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.showPODetails) ? _c('div', [(_vm.GRNPOData.length > 0) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('crossDock.po')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [(_vm.GRNPOData.length > 0) ? _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.poId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.drId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.GRNPOData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.poid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.drid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.po_grn_pen_qty))])])
  }), _vm._v(" "), (_vm.GRNPOData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)]) : _vm._e()]), _c('br'), _vm._v(" "), (_vm.totalPageInGRNPo && _vm.GRNPOData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInGRNPo,
      "total": _vm.totalRowsInGRNPo,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInGRNPo
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_grn_po')
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showReturnsDetails) ? _c('div', [(_vm.GRNReturnsData.length > 0) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('config.returns')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [(_vm.GRNReturnsData.length > 0) ? _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.returnsType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.wmsReturnId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.awbNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.GRNReturnsData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.returntype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.returnid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.quantity))])])
  }), _vm._v(" "), (_vm.GRNReturnsData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)]) : _vm._e()]), _c('br'), _vm._v(" "), (_vm.totalPageInGRNReturns && _vm.GRNReturnsData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInGRNReturns,
      "total": _vm.totalRowsInGRNReturns,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInGRNReturns
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_grn_returns')
      }
    }
  }) : _vm._e()], 1) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    staticClass: "alocationPopUp",
    attrs: {
      "size": "lg",
      "title": _vm.$t('crossDock.INPackingDetails')
    },
    model: {
      value: (_vm.showPackingBucketDetails),
      callback: function($$v) {
        _vm.showPackingBucketDetails = $$v
      },
      expression: "showPackingBucketDetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.wipBucketDetails')) + " : " + _vm._s(_vm.$t('wipInventory.inPacking')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showPackingBucketDetails = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.sku')) + " : " + _vm._s(_vm.sku) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.ean')) + " : " + _vm._s(_vm.eancode1) + " ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px",
      "padding": "10px"
    }
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseSummary')))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [(_vm.showPackingSalesOrderDetails) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('createsr.salesOrder')))])]) : _vm._e(), _vm._v(" "), (_vm.showPackingRTVDetails) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.rtv')))])]) : _vm._e(), _vm._v(" "), (_vm.showPackingGatepassDetails) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.gatepass')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center cardreporttabletr"
  }, [(_vm.showPackingSalesOrderDetails) ? _c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket['in_packing_order']))]) : _vm._e(), _vm._v(" "), (_vm.showPackingRTVDetails) ? _c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket['in_packing_rtv'] ? _vm.totalQtyInBucket['in_packing_rtv'] : 0))]) : _vm._e(), _vm._v(" "), (_vm.showPackingGatepassDetails) ? _c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket['in_packing_getpass']))]) : _vm._e()])])])]), _vm._v(" "), _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseDetails')) + " ")])]), _vm._v(" "), (_vm.showPackingSalesOrderDetails) ? _c('div', [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('createsr.salesOrder')))])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.packingSalesData), function(data) {
    return (_vm.packingSalesData.length > 0) ? _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.packing_pen_qty))])]) : _vm._e()
  }), _vm._v(" "), (_vm.packingSalesData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPageInPackingOrder && _vm.packingSalesData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInPackingOrder,
      "total": _vm.totalRowsInPackingOrder,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInPackingOrder
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_packing_order')
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showPackingRTVDetails) ? _c('div', [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.rtv')))])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.rtvId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.packingRTVData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.rtvid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rtv_pen_qty))])])
  }), _vm._v(" "), (_vm.packingRTVData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPageInPackingRTV && _vm.packingRTVData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInPackingRTV,
      "total": _vm.totalRowsInPackingRTV,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInPackingRtv
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_packing_rtv')
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showPackingGatepassDetails) ? _c('div', [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.gatepass')))])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.gatePassId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.packingGatepassData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.getpass_pen_qty))])])
  }), _vm._v(" "), (_vm.packingGatepassData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPageInPackingGetpass && _vm.packingGatepassData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInPackingGetpass,
      "total": _vm.totalRowsInPackingGetpass,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInPackingGetpass
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_packing_getpass')
      }
    }
  }) : _vm._e()], 1) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    staticClass: "alocationPopUp",
    attrs: {
      "size": "lg",
      "title": "IN GRN Details"
    },
    model: {
      value: (_vm.InGRNBucketDetails),
      callback: function($$v) {
        _vm.InGRNBucketDetails = $$v
      },
      expression: "InGRNBucketDetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.wipBucketDetails')) + " : " + _vm._s(_vm.$t('wipInventory.inGrn')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.InGRNBucketDetails = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.sku')) + " : " + _vm._s(_vm.skuNo) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.ean')) + " : " + _vm._s(_vm.EANNo) + " ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px",
      "padding": "10px"
    }
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseSummary')))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('purchaseOrder.po')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('config.returns')))])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center cardreporttabletr"
  }, [_c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket.in_grn_po))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket.in_grn_returns))])])])])]), _vm._v(" "), _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseDetails')) + " ")])]), _vm._v(" "), _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('purchaseOrder.po')))])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.poid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.drid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.GRNPOData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.poid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.drid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.po_grn_pen_qty))])])
  }), _vm._v(" "), (_vm.GRNPOData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPageInGRNPo && _vm.GRNPOData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInGRNPo,
      "total": _vm.totalRowsInGRNPo,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInGRNPo
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_grn_po')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('config.returns')))])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.returnsType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.wmsReturnId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.awbNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.GRNReturnsData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.returntype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.returnid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.quantity))])])
  }), _vm._v(" "), (_vm.GRNReturnsData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPageInGRNReturns && _vm.GRNReturnsData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInGRNReturns,
      "total": _vm.totalRowsInGRNReturns,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInGRNReturns
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_grn_returns')
      }
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    staticClass: "alocationPopUp",
    attrs: {
      "size": "lg",
      "title": "IN Packing Details"
    },
    model: {
      value: (_vm.InPackingBucketDetails),
      callback: function($$v) {
        _vm.InPackingBucketDetails = $$v
      },
      expression: "InPackingBucketDetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.wipBucketDetails')) + " : " + _vm._s(_vm.$t('wipInventory.inPacking')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.InPackingBucketDetails = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.sku')) + ": " + _vm._s(_vm.skuNo) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.ean')) + ": " + _vm._s(_vm.EANNo))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px",
      "padding": "10px"
    }
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseSummary')))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('createsr.salesOrder')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.rtv')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.gatepass')))])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center cardreporttabletr"
  }, [_c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket.in_packing_order))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket.in_packing_rtv ? _vm.totalQtyInBucket.in_packing_rtv : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket.in_packing_getpass))])])])])]), _vm._v(" "), _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseDetails')) + " ")])]), _vm._v(" "), _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('createsr.salesOrder')))])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.packingSalesData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.packing_pen_qty))])])
  }), _vm._v(" "), (_vm.packingSalesData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPageInPackingOrder && _vm.packingSalesData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInPackingOrder,
      "total": _vm.totalRowsInPackingOrder,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInPackingOrder
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_packing_order')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.rtv')))])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.rtvId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.packingRTVData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.rtvid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rtv_pen_qty))])])
  }), _vm._v(" "), (_vm.packingRTVData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPageInPackingRTV && _vm.packingRTVData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInPackingRTV,
      "total": _vm.totalRowsInPackingRTV,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInPackingRtv
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_packing_rtv')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.gatepass')))])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.gatePassId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.packingGatepassData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.getpass_pen_qty))])])
  }), _vm._v(" "), (_vm.packingGatepassData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPageInPackingGetpass && _vm.packingGatepassData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInPackingGetpass,
      "total": _vm.totalRowsInPackingGetpass,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInPackingGetpass
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_packing_getpass')
      }
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    staticClass: "alocationPopUp",
    attrs: {
      "size": "lg",
      "title": "IN PutAway Details"
    },
    model: {
      value: (_vm.InPutawayBucketDetails),
      callback: function($$v) {
        _vm.InPutawayBucketDetails = $$v
      },
      expression: "InPutawayBucketDetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.wipBucketDetails')) + " : " + _vm._s(_vm.$t('wipInventory.inPutaway')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.InPutawayBucketDetails = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.sku')) + ":  " + _vm._s(_vm.skuNo) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.ean')) + ": " + _vm._s(_vm.EANNo) + " ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px",
      "padding": "10px"
    }
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseSummary')))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('purchaseOrder.po')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('config.returns')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.cancelModifyOrder')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.moveOrder')))])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center cardreporttabletr"
  }, [_c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket.in_putaway_po))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket.in_putaway_returns))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket.in_putaway_cancle_modify))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalQtyInBucket.in_putaway_moveorder))])])])])]), _vm._v(" "), (_vm.inPutawayPoData.length > 0 || _vm.inPutawayReturnsData.length > 0 || _vm.inPutawayCancelOrder.length > 0 || !_vm.selectbucketwise) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseDetails')) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.inPutawayPoData.length > 0 || !_vm.selectbucketwise) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('purchaseOrder.po')))])]) : _vm._e(), _vm._v(" "), (_vm.inPutawayPoData.length > 0 || !_vm.selectbucketwise) ? _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.poid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.drid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.inPutawayPoData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.poid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.drid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.po_putaway_pen_qty))])])
  }), _vm._v(" "), (_vm.inPutawayPoData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.totalPageInPutawayPo && _vm.inPutawayPoData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInPutawayPo,
      "total": _vm.totalRowsInPutawayPo,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInPutawayPo
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_putaway_po')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inPutawayReturnsData.length > 0 || !_vm.selectbucketwise) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('config.returns')))])]) : _vm._e(), _vm._v(" "), (_vm.inPutawayReturnsData.length > 0 || !_vm.selectbucketwise) ? _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.returnsType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.wmsReturnId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.awbNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.inPutawayReturnsData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.returntype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.returnid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.putaway_pen_qty))])])
  }), _vm._v(" "), (_vm.inPutawayReturnsData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.totalPageInPutawayReturns && _vm.inPutawayReturnsData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInPutawayReturns,
      "total": _vm.totalRowsInPutawayReturns,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInPutawayReturns
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_putaway_returns')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inPutawayCancelOrder.length > 0 || !_vm.selectbucketwise) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.cancelModifyOrder')))])]) : _vm._e(), _vm._v(" "), (_vm.inPutawayCancelOrder.length > 0 || !_vm.selectbucketwise) ? _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.boxId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.inPutawayCancelOrder), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.can_pen_qty))])])
  }), _vm._v(" "), (_vm.inPutawayCancelOrder == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.totalPageInPutawayCancel && _vm.inPutawayCancelOrder.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInPutawayCancel,
      "total": _vm.totalRowsInPutawayCancel,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInPutawayCancel
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_putaway_cancle_modify')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inPutawayMoveorder.length > 0 || !_vm.selectbucketwise) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.moveOrder')))])]) : _vm._e(), _vm._v(" "), (_vm.inPutawayMoveorder.length > 0 || !_vm.selectbucketwise) ? _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.moveOrderId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.boxId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.inPutawayMoveorder), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.moveorderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.putaway_pen_qty))])])
  }), _vm._v(" "), (_vm.inPutawayMoveorder == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.totalPageInPutawayMoveOrder && _vm.inPutawayMoveorder.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInPutawayMoveOrder,
      "total": _vm.totalRowsInPutawayMoveOrder,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInPutawayMoveOrder
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_putaway_moveorder')
      }
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    staticClass: "alocationPopUp",
    attrs: {
      "size": "lg",
      "title": "IN Shipping Details"
    },
    model: {
      value: (_vm.InShippingBucketDetails),
      callback: function($$v) {
        _vm.InShippingBucketDetails = $$v
      },
      expression: "InShippingBucketDetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('wipInventory.wipBucketDetails')) + " : " + _vm._s(_vm.$t('wipInventory.inShipping')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.InShippingBucketDetails = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.sku')) + ":  " + _vm._s(_vm.skuNo) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.ean')) + ": " + _vm._s(_vm.EANNo))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px",
      "padding": "10px"
    }
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseSummary')))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [(_vm.showSalesOrder || !_vm.selectbucketwise) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('createsr.salesOrder')))])]) : _vm._e(), _vm._v(" "), (_vm.showrtvorder || !_vm.selectbucketwise) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.rtv')))])]) : _vm._e(), _vm._v(" "), (_vm.showgatepass || !_vm.selectbucketwise) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.gatepass')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center cardreporttabletr"
  }, [(_vm.showSalesOrder || !_vm.selectbucketwise) ? _c('td', [_vm._v(_vm._s(this.totalQtyInBucket.in_shipping_order))]) : _vm._e(), _vm._v(" "), (_vm.showrtvorder || !_vm.selectbucketwise) ? _c('td', [_vm._v("0")]) : _vm._e(), _vm._v(" "), (_vm.showgatepass || !_vm.selectbucketwise) ? _c('td', [_vm._v(_vm._s(this.totalQtyInBucket.in_shipping_getpass))]) : _vm._e()])])])]), _vm._v(" "), (_vm.inShippingOrderData.length > 0 || _vm.inShippingRTVData.length > 0 || _vm.inShippingGetpassData.length > 0) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.sourceWiseDetails')) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.inShippingOrderData.length > 0 || !_vm.selectbucketwise) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "#000000",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('createsr.salesOrder')))])]) : _vm._e(), _vm._v(" "), (_vm.inShippingOrderData.length > 0 || !_vm.selectbucketwise) ? _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.boxId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.packingBoxB2b')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.courier')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.awbNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.manifestid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.inShippingOrderData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.packingboxid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingcompany))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.manifestid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.packing_qty))])])
  }), _vm._v(" "), (_vm.inShippingOrderData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.totalPageInShippingOrderData && _vm.inShippingOrderData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInShippingOrderData,
      "total": _vm.totalRowsInShippingOrderData,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInShippingOrderData
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_shipping_order')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inShippingRTVData.length > 0 || !_vm.selectbucketwise) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.rtv')))])]) : _vm._e(), _vm._v(" "), (_vm.inShippingRTVData.length > 0 || !_vm.selectbucketwise) ? _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.rtvId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.boxId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.packingBoxB2b')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.courier')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.awbNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.manifestid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.inShippingRTVData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])
  }), _vm._v(" "), (_vm.inShippingRTVData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.inShippingGetpassData.length > 0 || !_vm.selectbucketwise) ? _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black",
      "margin-left": "10px",
      "height": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.gatepass')))])]) : _vm._e(), _vm._v(" "), (_vm.inShippingGetpassData.length > 0 || !_vm.selectbucketwise) ? _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.gatePassId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.boxId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('wipInventory.packingBoxB2b')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.courier')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.awbNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.manifestid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.inShippingGetpassData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.packingboxid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingcompany))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.manifestid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.packing_qty))])])
  }), _vm._v(" "), (_vm.inShippingGetpassData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.totalPageInShippingGetpassData && _vm.inShippingGetpassData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageInShippingGetpassData,
      "total": _vm.totalRowsInShippingGetpassData,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPageInShippingGetpassData
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange1($event, 'in_shipping_getpass')
      }
    }
  }) : _vm._e()], 1)])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e37f606", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e37f606","hasScoped":true}!./src/views/components/wipInventory/wipInventory.component.html
// module id = 2161
// module chunks = 0